module.exports = __webpack_public_path__ + "static/media/socialASSIST.c110b6cb.svg";